import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/interactive/tutorial.gif'


const _hoisted_1 = { class: "interactive-body" }
const _hoisted_2 = { class: "interactive-text" }
const _hoisted_3 = { class: "interactive-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      class: "interactive-gif",
      id: "pic",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('tutorial_text')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        size: 'large',
        text: _ctx.$t('challenge-level1'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoLevel1()))
      }, null, 8, ["text"])
    ])
  ]))
}